<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <VInput
      label="Стройка"
      name="name"
      required
      min-length="3"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="minLength">Минимальная длина названия 3 символа</Validation>
    </VInput>

    <VInput
      label="Город заказчика"
      name="customer_city"
    />

    <VSelect
      label="Руководитель"
      name="director"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VInput
      label="Заказ покупателя"
      name="buyer_order"
    />

    <VInput
      label="Шифр бух."
      name="accounting_cipher"
    />

    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
    />

    <AppInputDate
      title="Дата окончания"
      name="stop_date"
      type="single"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormPto from '@/components/pto/form/FormPto'
import Validation from '@/components/page/Form/Validation.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'

import { prepareBuildingRegisterFormData } from '@/utils/page/pto/buildingRegister'

export default {
  name: 'FormPtoBuildingRegister',
  components: {
    AppInputDate,
    FormPto,
    Validation,
    VInput,
    VSelect
  },

  mixins: [MIXIN_FORM_PTO, MIXIN_USER_LIST],

  methods: {
    onSubmit (data) {
      this.$emit('request', prepareBuildingRegisterFormData(data))
    }
  }
}
</script>
